import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import jpgImg from "../../../assets/user/images/1.jpg";
import Logo from "../../../assets/user/images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ApiService from "../../../core/services/ApiService";
import { api } from "../../../utlis/user/api.utlis";
import toast from "react-hot-toast";
import Loader from "../../../layouts/loader/Loader";
import { verifyOtp } from "../../../store/slices/Auth";
import { clearMessage } from "../../../store/slices/Message";
import OtpInput from "react-otp-input";
import CareBusiness from "../../../assets/user/images/carebusiness.svg";
import CareIndividual from "../../../assets/user/images/careIndividual.svg";
import CareUsers from "../../../assets/user/images/careuser.svg";
import InputMask from "react-input-mask";
import { countryCodes } from "../../../utlis/common.utlis";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [multiScreen, setMultiScreen] = useState(0);
  const [data, setData] = useState({ email: null });
  const { isLoggedIn, redirect } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message, shallowEqual);
  const [formError, setFormError] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true);
  const [tab, setTab] = useState(1);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsDisabled(false);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Type is required!"), // type must be present first
    email: Yup.string().when("type", {
      is: "E",
      then: (schema) =>
        schema
          .email("Please enter a valid email!")
          .required("Email address is required!"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
    phone: Yup.string().when("type", {
      is: "P",
      then: (schema) =>
        schema.min(14, "Phone is invalid").required("Phone is required!"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  });

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  // Move navigation logic to useEffect
  useEffect(() => {
    console.log("isLoggedIn:", isLoggedIn);
    console.log("redirect:", redirect);

    if (isLoggedIn) {
      navigate(redirect);
    }
  }, [isLoggedIn, redirect, navigate]);

  useEffect(() => {
    if (code.length === 4 && !formError) {
      verifyUser(); // Auto submit OTP once it's complete
    }
  }, [code, formError]);

  const sendOtp = async (formValue) => {
    setLoading(true);
    let form = JSON.stringify({
      email:
        formValue.type == "E"
          ? formValue.email
          : formValue.countryCode + " " + formValue.phone,
      user_type: formValue.user_type,
      login: true,
    });
    const response = await ApiService.postAPI(api.sendOtp, form);
    if (response.data.status) {
      toast.success(response.data.message);
      setData({
        email:
          formValue.type == "E"
            ? formValue.email
            : formValue.countryCode + " " + formValue.phone,
        user_type: formValue.user_type,
      });
      setTimer(30);
      setIsDisabled(true);
      setMultiScreen(1);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const verifyUser = () => {
    if (code.length !== 4) {
      setFormError(true);
      return;
    }
    setFormError(false);
    setLoading(true);
    dispatch(
      verifyOtp({ email: data.email, otp: code, user_type: data.user_type })
    )
      .unwrap()
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  const resendOtp = async () => {
    setLoading(true);
    let form = JSON.stringify({
      email: data.email,
      user_type: data.user_type,
      login: true,
    });
    const response = await ApiService.postAPI(api.sendOtp, form);
    if (response.data.status) {
      setTimer(30);
      setIsDisabled(true);
      toast.success(response.data.message);
    } else toast.error(response.data.message);
    setLoading(false);
  };

  const handleChange = (code) => setCode(code);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="auth-section auth-height">
        <div className="auth-bg-video">
          <img id="background-video" src={jpgImg} alt="" />
        </div>
        <div className="auth-content-card">
          <div className="container">
            <div className="auth-card">
              <div className="row">
                <div className="col-md-6">
                  <div className="user-auth-content1"></div>
                </div>
                {multiScreen === 0 ? (
                  <div className="col-md-6 authsign-form-info">
                    {/* <div className="auth-form"> */}
                    <div className="authsign-form">
                      <div className="brand-logo">
                        <img src={Logo} alt="logo" />
                      </div>
                      <h2 className="mb-2">Sign In</h2>
                      {/* <p>Find Senior Care & Housing Near You</p> */}
                      <Formik
                        initialValues={{
                          email: "",
                          phone: "",
                          type: "E",
                          user_type: tab,
                          countryCode: "+1",
                        }}
                        enableReinitialize={true}
                        validateOnChange={true}
                        validationSchema={validationSchema}
                        onSubmit={(formValue) => {
                          sendOtp({ ...formValue, user_type: tab });
                        }}
                      >
                        {({ values, setFieldValue }) => (
                          <Form className="">
                            <div className="form-group">
                              <div className="row g-2">
                                <div className="col-md-4">
                                  <div className="PBCheckbox">
                                    <input
                                      type="radio"
                                      name="user_type"
                                      id="Users"
                                      value="1"
                                      checked={tab === 1}
                                      onChange={() => {
                                        setTab(1);
                                        setFieldValue("user_type", 1);
                                      }}
                                    />
                                    <label htmlFor="Users">
                                      <span className="checkbox-circle-mark"></span>
                                      <div className="account-option-media">
                                        <img src={CareUsers} alt="Care Users" />
                                      </div>
                                      <div className="account-option-text">
                                        <h4>Care</h4>
                                        <h3>Users</h3>
                                      </div>
                                    </label>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="PBCheckbox">
                                    <input
                                      type="radio"
                                      name="user_type"
                                      id="Individual"
                                      value="3"
                                      checked={tab === 3}
                                      onChange={() => {
                                        setTab(3);
                                        setFieldValue("user_type", 3);
                                      }}
                                    />
                                    <label htmlFor="Individual">
                                      <span className="checkbox-circle-mark"></span>
                                      <div className="account-option-media">
                                        <img
                                          src={CareIndividual}
                                          alt="Care Individual"
                                        />
                                      </div>
                                      <div className="account-option-text">
                                        <h4>Care-Staff</h4>
                                        <h3>Individual</h3>
                                      </div>
                                    </label>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="PBCheckbox">
                                    <input
                                      type="radio"
                                      name="user_type"
                                      id="Business"
                                      value="2"
                                      checked={tab === 2}
                                      onChange={() => {
                                        setTab(2);
                                        setFieldValue("user_type", 2);
                                      }}
                                    />
                                    <label htmlFor="Business">
                                      <span className="checkbox-circle-mark"></span>
                                      <div className="account-option-media">
                                        <img
                                          src={CareBusiness}
                                          alt="Care Business"
                                        />
                                      </div>
                                      <div className="account-option-text">
                                        <h4>Care Provider</h4>
                                        <h3>Business</h3>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-2">
                                <div className="choosemiles-list">
                                  <ul>
                                    <li>
                                      <div className="ceradio">
                                        <Field
                                          type="radio"
                                          name="type"
                                          id="Email"
                                          value="E"
                                          onClick={() => {
                                            setFieldValue("type", "E");
                                            setFieldValue("phone", "");
                                          }}
                                        />
                                        <label
                                          for="Email"
                                          className="text-light"
                                        >
                                          <span className="checkbox-text">
                                            {" "}
                                            Email Address
                                          </span>
                                        </label>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="ceradio">
                                        <Field
                                          type="radio"
                                          name="type"
                                          id="Phone"
                                          value="P"
                                          onClick={() => {
                                            setFieldValue("type", "P");
                                            setFieldValue("email", "");
                                          }}
                                        />
                                        <label
                                          for="Phone"
                                          className="text-light"
                                        >
                                          <span className="checkbox-text">
                                            Phone
                                          </span>
                                        </label>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            {values.type === "P" && (
                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    as="select"
                                    name="countryCode"
                                    className="form-control"
                                    style={{ height: "51.5px", width: "160px" }}
                                  >
                                    {countryCodes.map((country) => (
                                      <option
                                        key={country.code}
                                        value={country.code}
                                      >
                                        {country.label} {country.code}
                                      </option>
                                    ))}
                                  </Field>
                                </div>
                                <div className="col-8">
                                  <div className="form-group">
                                    <Field name="phone">
                                      {({ field }) => (
                                        <InputMask
                                          {...field}
                                          mask="(999) 999-9999"
                                          className="form-control"
                                          maskChar=""
                                          onChange={(e) => {
                                            setFieldValue(
                                              field.name,
                                              e.target.value
                                            );
                                          }}
                                          placeholder="Enter phone"
                                        />
                                      )}
                                    </Field>
                                    <ErrorMessage
                                      name="phone"
                                      component="div"
                                      className="alert alert-danger"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                            {values.type === "E" && (
                              <div className="form-group">
                                <Field
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  placeholder="Email Address"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="alert alert-danger"
                                />
                              </div>
                            )}

                            <div className="form-group">
                              <button type="submit" className="auth-form-btn">
                                Get Verification Code
                              </button>
                            </div>

                            <div className="mt-1 forgotpsw-text">
                              <Link to={routes.signup}>
                                Don’t Have An Account? <b>Signup</b>
                              </Link>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                ) : (
                  <div className="col-md-6 auth-form-info">
                    <div className="auth-form">
                      <div className="brand-logo">
                        <img src={Logo} alt="logo" />
                      </div>
                      <h2>Verification Code</h2>
                      <p>
                        We have sent you a verification code to ({data.email})
                      </p>
                      <form className="pt-4">
                        <div className="form-group">
                          <div className="otp-item-input">
                            <OtpInput
                              value={code}
                              onChange={handleChange}
                              numInputs={4}
                              separator={<span style={{ width: "8px" }}></span>}
                              isInputNum={true}
                              shouldAutoFocus={true}
                              renderInput={(props) => <input {...props} />}
                              inputStyle={{
                                border: "1px solid transparent",
                                borderRadius: "8px",
                                width: "54px",
                                height: "54px",
                                fontSize: "1rem",
                                color: "#000",
                                fontWeight: "400",
                                caretColor: "blue",
                                margin: "0 5px",
                              }}
                              focusStyle={{
                                border: "1px solid #CFD3DB",
                                outline: "none",
                              }}
                            />
                          </div>
                          {message && (
                            <div
                              className="form-group text-center mt-4 mb-0"
                              style={{ fontSize: "0.9rem" }}
                            >
                              <div className="alert alert-danger" role="alert">
                                {message}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="my-2 forgotpsw-text d-flex justify-content-center align-items-center">
                          <p>
                            {timer != 0 && (
                              <>
                                Didn't receive a code? Resend (<b>{timer}</b>)
                              </>
                            )}
                          </p>
                          {!isDisabled && (
                            <Link to="" onClick={() => resendOtp()}>
                              {" "}
                              Resend Verification Code{" "}
                            </Link>
                          )}
                        </div>
                        <div className="form-group">
                          <button
                            type="button"
                            className="auth-form-btn"
                            onClick={() => verifyUser()}
                          >
                            Validate Verification Code
                          </button>
                        </div>
                        <div className="form-group">
                          <Link
                            onClick={() => {
                              setData({ email: null });
                              setMultiScreen(0);
                              setCode("");
                            }}
                          >
                            Back
                          </Link>
                        </div>
                      </form>
                      {formError && (
                        <div className="alert alert-danger">
                          OTP is required
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
